module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Title_Page"
  }, [_c('h2', {
    staticClass: "chaptitle3"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Contents#ch10",
      "id": "rch10"
    }
  }, [_c('b', [_vm._v("The Tagish Elvis")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub2"
  }, [_c('b', [_vm._v("There are Elvis impersonators, and then there’s this guy. He seems so convinced that he actually is the King…that we’re not going to rule out that possibility.")])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p36.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Kung Fu Elvis")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_vm._v("ALL SHOOK UP")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“The UFO came over my head,” said Elvis Aaron Presley. “And it zapped me with its light. I had this vision that I was wearing a maroon-coloured outfit, and the rhinestones on it were glowing. And I said, ‘Holy sh*t, what’s going on here? That’s Elvis! But it’s me, too!’ ” He said he could actually feel Elvis’ DNA supplanting his own. Memories of the real Presley flooded his mind, as did the reason for his bizarre transformation: The U.S. government had hypnotized Elvis Presley in 1977 and sent him to the Yukon to live in obscurity as “Gilbert Nelles.” Thirteen years later, he was “reactivated.” The aliens told him so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the encounter, Nelles dyed his reddish-blond hair black and legally changed his name to Elvis Aaron Presley. Now he wears a sequined jumpsuit, oversized sunglasses, has jet-black sideburns, and speaks in the same Southern cadence as the King.")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p37.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("“Elvis” in the "), _c('i', [_vm._v("Dragons’ Den")]), _vm._v(".")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_vm._v("SUSPICIOUS MINDS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But it’s not like Nelles was “normal” up until his alien encounter. He’d been known in the small Yukon town of Tagish to be a bit…eccentric. He’d tell people to watch what they say, because the CIA was monitoring him. He spent his evenings at bingo and karaoke, and made a modest living painting landscapes onto gold pans and selling them to tourists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Locals say their Elvis really started losing it in the cold winter of 1990. That’s when he built himself a cabin in the woods out of old, discarded telephone poles. The chemicals used to preserve the poles emitted noxious fumes—which may be to blame for his visions and belief that he’s Elvis. But to hear the man tell his odd tale, he doesn’t come off like a loony. He sounds more like…Elvis (the latter, drug-addled Vegas version). And he’s got lots of faithful fans: “People actually kiss my feet and say, ‘Elvis, the Lord has brought you back to us!’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_vm._v("VIVA LAS VEGAS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the three decades since his transformation, the Tagish Elvis has become something of a celebrity. One of his proudest moments was when he performed with (the real) Chubby Checker in Las Vegas. One of his lowest points also happened in Sin City: He was assaulted at a party by a group of men, who left him with two black eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Back in the Yukon, you might see Elvis tooling around in his old pink Cadillac (decorated with plaster cherubs). And if you head up there to do some gold panning, you might be lucky enough to be serenaded by the King himself—he has a kiosk set up at a mining site. Bonus: He really does sound a lot like Elvis Presley!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And he doesn’t just sing covers. He’s written and recorded three albums of Elvis-style music: "), _c('i', [_vm._v("Still Living")]), _vm._v(" (1996), "), _c('i', [_vm._v("Armageddon Angel")]), _vm._v(" (2003), and "), _c('i', [_vm._v("A King’s Ransom")]), _vm._v(" (2007). He was even the subject of a 2008 independent documentary film called "), _c('i', [_vm._v("The Elvis Project")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p38-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("“Elvis” being Elvis")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('b', [_vm._v("JAILHOUSE ROCK")])])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Aside from singing, one of Elvis’ favorite things to do is sue people. His legal adventures began in 1996 when his wife, fed up with her husband’s paranoid visions, told him she was moving out of the cabin. Enraged, Elvis accused her of being yet another pawn in the U.S. government’s attempts to control him and then shot his gun toward her, but missed. When Mounties showed up and arrested him, one of them mentioned that he should seek “professional help.” Elvis filed a $1-million lawsuit against the RCMP for defamation. The judge dismissed the case and charged him $10 for “wasting everybody’s time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But that was just the beginning. According to CBC News, “Elvis has sued just about every legal authority in the country, including police officers, lawyers, judges, the RCMP Complaints Commissioner, and even the Solicitor General of Canada.” He even once sued adult magazine magnate Larry Flynt for featuring the Tagish Elvis as the “*ssh*le of the Month” in "), _c('i', [_vm._v("Hustler")]), _vm._v(". Elvis wanted millions, but said he would be satisfied with a simple apology. So Flynt, not wanting to go to court, printed a short “sorry for calling you a crazy *ssh*le” note in the next issue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Elvis would always represent himself in court. Dressed in full Elvis regalia, he was known to break out in song during his depositions. His rambling affidavits consisted of hundreds of pages of alien abduction and mind control stories. Finally, in 2003 a judge in Whitehorse called Elvis a “vexatious litigant” whose suits were all “gibberish.” He was fined $10,000 and banned from filing lawsuits. Elvis left the building…but not before threatening to sue the judge for $120 million.")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p38-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("“Elvis” gets the runs.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_vm._v("DON’T BE CRUEL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Where do troubled individuals eventually wind up? Politics, of course. In 2005 Elvis ran for the leadership position of the Yukon Liberal Party, but garnered only five votes. He fared somewhat better the following year, when he got 40 votes while running as an Independent for the Yukon legislature, promising to fix the corrupt court system. He lost, but tried again in 2011, using the slogan, “Be A Hound Dog, Vote Elvis Presley, Make Yukon Graceland.” He lost again.")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('b', [_vm._v("HEARTBREAK HOTEL")])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Those defeats, however, were nothing compared to the drubbing he took on national television. The Tagish Elvis performed before his largest audience ever in 2010 when, at age 54, he appeared on the game show "), _c('i', [_vm._v("Dragon’s Den")]), _vm._v(", in which contestants pitch their business proposals to a panel of grumpy rich people. Wearing a white jumpsuit, Elvis burst on stage singing an “Elvis original” (that he wrote) called “Country Child.” Then he told the Dragons about the aliens. Not surprisingly, the Dragons mocked him, but Elvis stood his ground and pitched his pitch: For only $58,000, he’d sell them a 15-percent stake in his next two albums. He also offered up his memorabilia for sale. The answer: No. And not just no, but Dragon Kevin O’Leary called him a “nutbar.” Elvis responded, “I’m making a chocolate bar called the Nutbar. We should go into business together.” The answer: still no. Inspired by the insult, Elvis has since released the “Elvis Presley Nut Bar Experience Chocolate Bar” (which contains no nuts).")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p39.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("“Elvis” takes a question.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_vm._v("RETURN TO SENDER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Currently residing in Ross River, Yukon, he’s still doing what he does best: being Elvis Presley. As he says on his website, “I have an affinity for writing smooth lyrics set to upbeat dancing music containing a country, pop, rock, easy-listening style flavored with a First Nation cultural musical styling, creating a new unique musical genre with a spiritual depth easily absorbed by all.”")]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_c('b', [_vm._v("THE EIFFEL TOWER, NOW A BELOVED SYMBOL, WAS ONCE LAMBASTED BY CRITICS AS UGLY AND UNSAFE.")])])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f281644","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/017_Chapter10.vue
// module id = 108
// module chunks = 0